module.exports = __webpack_public_path__ + "static/media/cross.2288c41c.svg";